import { createFormHook } from "@tanstack/react-form";

import { FormFieldCaption } from "../components/form-field-caption";
import { FormFieldCheckbox } from "../components/form-field-checkbox";
import { FormFieldCombobox } from "../components/form-field-combobox";
import { FormFieldError } from "../components/form-field-error";
import { FormFieldInput } from "../components/form-field-input";
import { FormFieldLabel } from "../components/form-field-label";
import { FormFieldMultiSelect } from "../components/form-field-multi-select";
import { FormFieldRadioGroup } from "../components/form-field-radio-group";
import { FormFieldSelect } from "../components/form-field-select";
import { FormFieldSelectFilter } from "../components/form-field-select-filter";
import { FormFieldSwitch } from "../components/form-field-switch";
import { SubmitButton } from "../components/submit-button";
import {
  fieldContext,
  formContext,
  useFieldContext,
} from "../core/form-contexts";

const fieldComponents = {
  Caption: FormFieldCaption,
  Error: FormFieldError,
  Label: FormFieldLabel,
  Input: FormFieldInput,
  Checkbox: FormFieldCheckbox,
  Switch: FormFieldSwitch,
  RadioGroup: FormFieldRadioGroup,
  Select: FormFieldSelect,
  SelectFilter: FormFieldSelectFilter,
  Combobox: FormFieldCombobox,
  MultiSelect: FormFieldMultiSelect,
};

const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents,
  formComponents: {
    SubmitButton,
  },
});

// Strongly typed field API that includes UI slots wired by createFormHook
type FieldComponents = typeof fieldComponents;
type FieldWithSlots<TValue> = ReturnType<typeof useFieldContext<TValue>> &
  FieldComponents;

function useFieldWithSlots<TValue>(): FieldWithSlots<TValue> {
  return useFieldContext<TValue>() as FieldWithSlots<TValue>;
}

export { useAppForm, withForm, useFieldWithSlots };
export type { FieldWithSlots };
